(function () {
  'use strict';

  var container = document.querySelector('.article-rating__stars');
  if (!container) return;

  var articleId = container.dataset.articleId;
  var key = 'article_star_' + articleId;
  var stars = Array.prototype.slice.call(container.querySelectorAll('.article-rating__star'));
  var prompt = document.querySelector('.article-rating__prompt');
  var thanks = document.querySelector('.article-rating__thanks');
  var userVote = localStorage.getItem(key);

  function setStars(value) {
    stars.forEach(function (star, i) {
      star.classList.toggle('active', i < value);
    });
  }

  function disableRating(value) {
    setStars(value);
    container.classList.add('voted');
    if (prompt) prompt.style.display = 'none';
    if (thanks) thanks.style.display = 'block';
  }

  if (userVote) {
    disableRating(parseInt(userVote, 10));
    return;
  }

  stars.forEach(function (star, index) {
    star.addEventListener('mouseenter', function () {
      setStars(index + 1);
    });

    star.addEventListener('click', function () {
      var value = parseInt(star.dataset.value, 10);
      localStorage.setItem(key, value);
      disableRating(value);
    });
  });

  container.addEventListener('mouseleave', function () {
    setStars(0);
  });
})();
